
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'


export default {
name: 'HomeDownload',
components: {
Flexbox,
FlexboxItem
},
data () {
return {
title: '潮州侨联'
}
},
created () {
},
methods: {
toiOS () {
let ua = window.navigator.userAgent.toLowerCase()
if (ua.indexOf('micromessenger') > -1) {
this.$alert('请点击右上角，使用默认浏览器打开', 'Tips', {
confirmButtonText: '确定'
})
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/home/download.vue